import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import searchAPI from 'utils/searchAPI';
import debounceFunc from 'utils/debounceFunc';

import './style.scss';

const {
  i18n: {
    __,
  },
} = wp;

export default class ExpandableSearch extends PureComponent {
  /**
   * Set PropTypes for this component.
   *
   * @type {object}
   */
  static propTypes = {
    setSearchResults: PropTypes.func.isRequired,
    setIsLoading: PropTypes.func.isRequired,
    setHasSearchQuery: PropTypes.func.isRequired,
    setHasSearched: PropTypes.func.isRequired,
    setSearchQuery: PropTypes.func.isRequired,
    setTopMenuIndex: PropTypes.func.isRequired,
    handleToggleState: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.getSearchResults = debounceFunc(this.getSearchResults, 1000);
  }

  state = {
    searchExpanded: false,
    query: '',
  };

  getSearchResults = () => {
    const { query } = this.state;
    const {
      setSearchResults,
      setIsLoading,
      setHasSearched,
      setTopMenuIndex,
    } = this.props;

    if (1 <= query.length) {
      setIsLoading(true);
      setTopMenuIndex(0, true);
      searchAPI.searchVideos(query)
        .then((res) => {
          setSearchResults(res.template_items);
        });
    } else {
      setSearchResults([]);
      setHasSearched(false);
    }
  };

  /**
   * Handle form submission.
   */
  handleOnSubmit = (e) => {
    e.preventDefault();

    if (1 <= this.state.query.length) {
      this.getSearchResults();
    }
  };

  /**
   * Handle the button click.
   */
  handleClick = () => {
    this.setState((prevState) => ({
      searchExpanded: ! prevState.searchExpanded,
    }));
  };

  handleOnChange = (e) => {
    const { value } = e.target;
    const { setHasSearchQuery, setHasSearched, setSearchQuery } = this.props;

    if (1 <= value.length) {
      setHasSearchQuery(true);
    } else {
      setHasSearchQuery(false);
      setHasSearched(false);
    }

    setSearchQuery(value);

    this.setState(
      { query: value },
      () => this.getSearchResults()
    );
  };

  render() {
    const { searchExpanded } = this.state;

    const { setToggleSearch } = this.props.handleToggleState;

    const searchOpenClasses = searchExpanded ?
      'expandable-search search-open' :
      'expandable-search';

    const showSearchClasses = setToggleSearch ?
      ' hide-search' :
      ' show-search';

    return (
      <div className={searchOpenClasses + showSearchClasses}>
        <button
          className="expandable-search__toggle"
          onClick={this.handleClick}
          type="button"
        >
          <span className="expandable-search__toggle-text">
            {__('Search', 'nbc')}
          </span>
        </button>
        <div className="expandable-search__form">
          <form
            className="search-form search-form--video"
            role="search"
            onSubmit={this.handleOnSubmit}
          >
            <label htmlFor="video-search">
              <span className="screen-reader-text">
                {__('Search Videos:', 'nbc')}
              </span>
              <input
                id="video-search"
                type="search"
                name="s"
                placeholder={__('Search Videos', 'nbc')}
                onChange={this.handleOnChange}
                value={this.state.query}
              />
            </label>
            <input
              type="submit"
              className="search-submit"
              value={__('Search', 'nbc')}
            />
          </form>
        </div>
      </div>
    );
  }
}
